import UserResource, { UserMenuProps } from "./User/User";
import CampaignResource, { CampaignMenuProps } from "./Campaign/Campaign";
import ChallengeResource, { ChallengeMenuProps } from "./Challenge/Challenge";
import CampaignChallengeResource, {
	CampaignChallengeMenuProps,
} from "./CampaignChallenge/CampaignChallenge";
import DonationResource, { DonationMenuProps } from "./Donation/Donation";
import FileResource, { FileMenuProps } from "./File/File";
import RubricResource, { RubricMenuProps } from "./Rubric/Rubric";
import PageResource, { PageMenuProps } from "./Page/Page";
import RegionResource from "./Region/Region";
import EntityResource from "./Entity/Entity";
import PageCategoryResource from "./PageCategory/PageCategory";
import ProjectResource, { ProjectMenuProps } from "./Project/Project";
import FundraisingCampaignResource, {
	FundraisersCampaignMenuProps,
} from "./FundraisersCampaign/FundraisersCampaign";

const enumResources = [
	{ name: "enum_campaign_status" },
	{ name: "enum_challenge_status" },
	{ name: "enum_news_status" },
	{ name: "enum_entity_type" },
	{ name: "enum_file_type" },
];

/* MenuProps Format: {to: String, primaryText: String, icon: Icon} */
export const resourceMenu = [
	ChallengeMenuProps,
	CampaignMenuProps,
	CampaignChallengeMenuProps,
	FundraisersCampaignMenuProps,
	RubricMenuProps,
	PageMenuProps,
	DonationMenuProps,
	UserMenuProps,
	ProjectMenuProps,
];

export default [
	ChallengeResource,
	CampaignResource,
	CampaignChallengeResource,
	FundraisingCampaignResource,
	RubricResource,
	PageResource,
	DonationResource,
	UserResource,
	FileResource,
	RegionResource,
	EntityResource,
	PageCategoryResource,
	ProjectResource,
	...enumResources,
];
